import React, { useContext } from "react";
import "./Camera.css";
import Card from "../Card/Card";
import Oculus from "../../img/vr1.png";
import Board from "../../img/board.png";
import HT from "../../img/vr2.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";

const Camera = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="camera" id="camera">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "#b0d12a" : "" }}>Camera For Try</span>
        <span>Virtual Reality</span>
        <spane style={{ color: darkMode ? "white" : "" }}>
          Here are some VR cameras that you can try to enjoy the virtual world.
          <br />
          Here I suggest several cameras from paid ones to those that can be made yourself
          <br />
          or you can just use a smartphone that is already supported.
        </spane>
        {/* <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a> */}
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div initial={{ left: "25rem" }} whileInView={{ left: "14rem" }} transition={transition}>
          <Card emoji={Oculus} heading={"Oculus Quest 2"} detail={"Quest 2 is non-stop fun. The biggest titles and multiplayer games—we have them."} />
        </motion.div>
        {/* second card */}
        <motion.div initial={{ left: "-11rem", top: "12rem" }} whileInView={{ left: "-4rem" }} transition={transition}>
          <Card emoji={HT} heading={"HTC Vive Pro 2"} detail={"Next-level graphics and sound for riveting PC-VR. Purposeful and pragmatic ergonomics delivers smooth."} />
        </motion.div>
        {/* 3rd */}
        <motion.div initial={{ top: "19rem", left: "25rem" }} whileInView={{ left: "12rem" }} transition={transition}>
          <Card emoji={Board} heading={"VR Cardboard"} detail={"Experience virtual reality in a simple,fun, and affordable way. You must try it for alternative."} color="rgba(252, 166, 31, 0.45)" />
        </motion.div>
        <div className="blur s-blur2" style={{ background: "var(--purple)" }}></div>
      </div>
    </div>
  );
};

export default Camera;
